export default function dateResolve(input, time = true) {
  let date = new Date(input);

  let appendTime = "";
  let amPm = "AM";

  if (time === true) {
    let prependMinutes = "";
    if (date.getMinutes() < 10) prependMinutes = "0";
    let prependSeconds = "";
    if (date.getSeconds() < 10) prependSeconds = "0";
    let hours = date.getHours();
    if (hours > 12) {
      hours -= 12;
      amPm = "PM";
    }
    appendTime = hours + ":" + prependMinutes + date.getMinutes() + ":" + prependSeconds + date.getSeconds() + " " + amPm;
  }

  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  return date.getDate() + " " + monthNames[date.getMonth()] + " " + date.getFullYear() + " " + appendTime;
}
